module.exports = __webpack_public_path__ + "static/media/main_slider_1.c6a092c1.jpg";